import React, { useMemo } from 'react';
import { Button, Tooltip } from 'antd';
import getPercentage from '@utils/percentage';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { bytesFormat } from '@utils/formatters';

import * as S from './styles';

interface ContractConsumeCardProps {
  label: string;
  consumption: number;
  franchise: number;
  surplus?: string;
  loading?: boolean;
}

const ContractConsumeCard = ({
  label,
  consumption,
  franchise,
  surplus,
  loading,
}: ContractConsumeCardProps) => {
  const { t } = useTranslation('dashboard');

  const percentage = useMemo(() => {
    const result = getPercentage(Number(consumption), Number(franchise), 2);
    return Number.isNaN(result) ? 0 : result;
  }, [consumption, franchise]);

  return (
    <S.CardProgressContainer loading={loading}>
      <strong>
        {t(`shared-contracts.${label}Consumption`)}
        <Tooltip title={t(`shared-contracts.${label}ConsumptionHelp`)}>
          <Button type="link" icon={<InfoCircleOutlined />} />
        </Tooltip>
      </strong>
      <S.CardProgressBar percentage={percentage}>
        <div className="progress-inner">
          <span className="progress-bg" />
        </div>
        <span className="progress-value">{`${percentage}%`}</span>
      </S.CardProgressBar>
      <S.CardProgressFooter>
        <span>
          {`${t(`shared-contracts.consumption`)}: `}
          <strong>{bytesFormat(consumption)}</strong>
        </span>
        <span>
          {`${t(`shared-contracts.franchise`)}: `}
          <strong>{bytesFormat(franchise)}</strong>
        </span>
        {surplus && surplus !== '0' && (
          <span>
            {`${t(`shared-contracts.surplus`)}: `}
            <strong className="shared-contracts-surplus">
              {bytesFormat(surplus)}
            </strong>
          </span>
        )}
      </S.CardProgressFooter>
    </S.CardProgressContainer>
  );
};

export default ContractConsumeCard;
